import React from "react";
import { FormControlLabel, Checkbox } from "@mui/material";

import HoverText from "modules/documents/components/action-buttons/hoverText";

import { IContentBandSettingsInputProps } from "../editor/contentBandSettingsForm";

export const EnableSeeMoreInput: React.FunctionComponent<IContentBandSettingsInputProps<boolean>> = ({
    idx,
    onChange,
    value,
    isSmallAndSmaller,
}) => {
    return (
        <div className="form-group">
            <div style={isSmallAndSmaller ? undefined : { marginLeft: "auto", width: 250 }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            className="checkbox"
                            color="primary"
                            checked={value}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.checked, idx)}
                        />
                    }
                    label={
                        <HoverText labelClassName="input" label="Enable See more link">
                            The see more link directs mobile app users to a feed with all posts or events that match the content settings of
                            this content band.
                        </HoverText>
                    }
                />
            </div>
        </div>
    );
};
